import './nav';
import './home';
import './properties';



// WEBPACK FOOTER //
// ./scripts/index.js